/* This file is part of the Template for the project
it allows you to override base level components and elements.
Currently it is overriding the root, body, and light&dark scheme.
It manages the layout, color scheme for light and dark when you need specific adjustments. */

html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;

}

body {
  /* Required to make the body take up the full viewport height and width */
  height: 100vh;
  width: 100vw;
}

.MuiButtonBase-root-MuiIconButton-root {
  background-color: #1F4D83 !important;

}

.MuiToolbar-root {
  min-height: 44px !important;
  /* Adjust the height of the toolbar */
}


/* font-family: system-ui, Avenir, Helvetica, Arial, sans-serif; */

:root {
  font-family: Arial;
  line-height: 1.5;
  font-weight: 400;
  flex-grow: 1;
  display: flex;
  margin-top: 0px;
  border-radius: 2px !important;
  color-scheme: light dark;
  color: rgba(255, 255, 255, 0.87);
  background-color: #242424;

  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  font-weight: 500;
  color: #646cff;
  text-decoration: inherit;
}

a:hover {
  color: #08335d;
}

h1 {
  font-size: 3.2em;
  line-height: 1.1;
}

button {
  border-radius: 2px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1rem;
  font-weight: 500;
  font-family: inherit;
  background-color: #1F4D83;
  cursor: pointer;
  transition: border-color 0.25s;
}

button:hover {
  border-color: #0092C8;
  background-color: #0092C8;
}

button:active {
  background-color: #0072A1;
  border-color: #0072A1;
}

button:focus,
button:focus-visible {
  outline: 1px auto -webkit-focus-ring-color;
}

@media (prefers-color-scheme: light) {
  :root {
    color: #213547;
    background-color: #ffffff;
  }

  a:hover {
    color: #747bff;
  }

  button {
    background-color: #1F4D83;
  }
}

/* custom scrollbar styles to help in looking modern */
::-webkit-scrollbar {
  width: 8px;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(150, 150, 150, 0.4);
  border-radius: 12px;
  border: 2px solid transparent;
  background-clip: padding-box;
  min-height: 40px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(120, 120, 120, 0.6);
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 12px;
}

/* Firefox scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(150,150,150,0.4) transparent;
}